<template>   
  <div>
    <v-card flat>      
        <div>
          <v-row no-gutters fill-height>
            <v-expansion-panels
              v-model="panel"
              :disabled="disabled"
              multiple 
              accordion     
            >
              <v-expansion-panel>
                <v-expansion-panel-header>Select Condition</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <!-- =============Start Search Condition============= -->
                      <v-row dense class="ma-0">
                        <v-col
                          class="pl-0"
                          cols="6"
                          sm="6"
                          md="4"
                        >                           
                        <DxDateBox  
                            label="Insp.Date"                            
                            :value="stDate" 
                            display-format="yyyy-MM-dd" 
                            :acceptCustomValue="false"
                            @value-changed="e => {stDate = e.value && getStrFormat(e.value)}"
                            dense
                        />
                        </v-col>

                        <v-col                            
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >
                            <v-select 
                              label="Ship No"
                              v-model="shipNo" 
                              :items="shipNoList" 
                              return-object 
                              item-value="shipNo" 
                              outlined
                              dense
                            >
                            </v-select>
                        </v-col>

                        <v-col
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >
                            <v-select 
                              label="Department"
                              v-model="deptName" 
                              :items="deptNameList" 
                              item-value="deptName" 
                              return-object 
                              outlined 
                              dense
                              @change = "groupList"
                            >
                            </v-select>
                        </v-col>

                        <v-col
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >
                            <v-select 
                              label="Group"
                              v-model="respName" 
                              :items="respNameList" 
                              item-value="respName"
                              return-object
                              outlined 
                              dense
                              
                            >
                            </v-select>
                        </v-col>
                        <!-- QM Part -->
                        <v-col                            
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >
                            <v-select 
                              label="QM Part"
                              v-model="qmPartName" 
                              :items="qmPartNameList" 
                              return-object 
                              item-value="qmPartName" 
                              outlined
                              dense
                            >
                            </v-select>
                        </v-col>
                        <!-- <v-col
                          cols="6"
                          sm="6"
                          md="4"
                        >
                          <v-btn 
                          
                            height = "30px"
                            class="mt-2 "
                            block
                            dense
                            color="success"
                            @click="btnRetrieve"
                          >
                            <v-icon left>
                              {{ icons.mdiMapSearch }}
                            </v-icon>
                            Retrieve
                          </v-btn>
                        </v-col> -->
                      </v-row>
                    <!-- ==========End Search Condition================= -->
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </div>
        <!-- Change theme -->
        <v-fab-transition>
          <v-btn
            v-show="!isMobileDevice" 
            @click="btnRetrieve"
            absolute
            top
            right
            fab
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-fab-transition>
    </v-card> 
    
    <v-card class="mt-2">  
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>  
           <div class="ml-2">Count List: {{ gridMainList.length }}</div>
          <!-- :items="gridMainList"  -->
          <v-data-table
            :mobile-breakpoint="800"
            :mobile="mobile"
            :items-per-page="15"
            :headers="headers"
            :items="filteredItems"
            fixed-header
            :height="isMobileDevice ? undefined : 600"
            :search="search"
            :dense="true"
            :sort-by="[]"
            :sort-desc="[false]"
            :dark="dark"
            class="mobile-clean-table"
            style="max-width: 100%; overflow-x: auto;"
          >    
              <template v-if="!isMobileDevice" v-for="header in headers" v-slot:[`header.${header.value}`]="{ header }">
                <div :key="header.value" class="custom-header-cell">
                  <span class="header-text">{{ header.text }}</span>
                  
                  <v-menu offset-y :close-on-content-click="false" bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon x-small v-bind="attrs" v-on="on" 
                        :color="columnFilters[header.value] ? 'primary' : 'grey lighten-1'">
                        <v-icon size="14">mdi-filter-variant</v-icon>
                      </v-btn>
                    </template>

                    <v-card width="200" class="pa-2">
                      <v-text-field
                        v-model="columnFilters[header.value]"
                        :label="'Filter ' + header.text"
                        outlined dense hide-details clearable
                        class="custom-filter-input"
                        @click.stop
                        autofocus
                      ></v-text-field>
                    </v-card>
                  </v-menu>
                </div>
              </template>

              <template v-slot:item="{ item, isMobile }">
    
                <mobile-card-item
                    v-if="isMobile"
                    :item="item"
                    :header-value="item.rno"
                    :active="selectedRowIndex === item.rno"
                    :fields="mobileFields"
                    @click="showDetail(item)"             
                    >
                                         
                   
                </mobile-card-item>

                <tr v-else class="custom-pc-row">
                  <!-- <td class="text-center v-data-table__divider">
                    <v-chip :color="getColor(item.rno)" dark>{{ item.rno }}</v-chip>
                  </td> -->
                  <td class="v-data-table__divider">{{ item.rno }}</td>
                  <td class="v-data-table__divider">{{ item.shipNo }}</td>
                  <td class="v-data-table__divider">{{ item.insDate }}</td>
                  <td class="v-data-table__divider">{{ item.reqDate }}</td>
                  <td class="v-data-table__divider">{{ item.deptNm }}</td>
                  <td class="v-data-table__divider">{{ item.respNmeng }}</td>
                  <td class="v-data-table__divider">{{ item.itemDescShort }}</td>
                  <td class="v-data-table__divider">{{ item.ndtKind }}</td>
                  <td class="v-data-table__divider">{{ item.qmPart }}</td>                  
                  <td class="v-data-table__divider">{{ item.insLocNo }}</td>
                  <td class="v-data-table__divider">{{ item.insRes }}</td>
                  <td class="v-data-table__divider">{{ item.wedEmp }}</td>
                  <td class="v-data-table__divider">{{ item.ndtNo }}</td>
                  
                </tr>
              </template>

          </v-data-table>   
          <!-- v-dialog show Detail -->
          <v-dialog v-model="detailDialog" max-width="650px" scrollable>
                <v-card v-if="selectedItem">
                    <v-card-title class="headline grey lighten-2">
                    Detail Info (No. {{ selectedItem.rno }})
                    <v-spacer></v-spacer>
                    <v-btn icon @click="detailDialog = false"><v-icon>mdi-close</v-icon></v-btn>
                    </v-card-title>

                    <v-card-text class="pa-4">
                    <div v-for="(field, i) in headers" :key="i" class="mb-3 border-bottom pb-1">
                        <div class="caption grey--text text-uppercase">{{ field.text }}</div>

                        <div class="subtitle-1 font-weight-medium black--text">                         
                          
                          <template >
                            {{ selectedItem[field.value] || '-' }}
                          </template>
                        </div>
                    </div>
                    </v-card-text>

                    <v-divider></v-divider>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="detailDialog = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>                          
    </v-card>

    <!-- Scroll To Top -->
    <v-btn
      v-scroll="onScroll"
      v-show="fab && isMobileDevice"
      fab
      dark
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
      style="z-index: 1000;"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>

  </div>  
</template>

<script>
import  {
        mdiAccount,
        mdiPencil,
        mdiShareVariant,
        mdiDelete,
        mdiSelectSearch,
        mdiMapSearch 

      } from '@mdi/js'

import  { getShipList, 
        getDeptList,
        getRespList,
        getQMPartList,
      } from '@/api/view/tqm/80/v80comm.js'

import  {
        v80c1010List,
      } from '@/api/view/tqm/80/v80c1010.js'

import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page addition
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // Add base when using data grid
import { mobileTableMixin } from '@/mixins/mobileTableMixin.js' // Import mixin mới
import { columnFilterMixin } from '@/mixins/columnFilterMixin.js'
import EventBus from '@/components/event-bus';

import {
getDateFormat,
} from '@/utils/common.js'



export default {
name: "v80c1010",
mixins: [baseview, BaseDataGrid, mobileTableMixin,columnFilterMixin],
data: () => ({
  fab: false,
  dark: false,
  isMobileDevice: false, // Biến mới
  icons: {
    mdiAccount,
    mdiPencil,
    mdiShareVariant,
    mdiDelete,
    mdiSelectSearch,
    mdiMapSearch

  },
  stDate: '',
  shipNoList: [],
  shipNo: '',
  deptName: '',
  deptNameList: [],
  deptCd: '',
  respName: '',
  respNameList: [],
  respCd: '',
  qmPart: '',
  qmPartName:'',
  qmPartNameList: [],
  panel: [0],
  disabled: false,
  hover: true,

  // data
  gridMainList: [],
  listSize: 0,
  
  mobile: true,
  search: '',
  headers: [
              {
                text: 'No',
                align: 'center',
                value: 'rno',
                sortable: false,
                width: '20px'
              },
              { text: 'Ship No', sortable: false, align: 'center',value: 'shipNo',  },
              { text: 'Insp. Date', sortable: true, align: 'center',value: 'insDate',  },
              { text: 'Req. Date', sortable: true, align: 'center',value: 'reqDate',  },
              { text: 'Department', sortable: false, align: 'center',value: 'deptNm',   },
              { text: 'Work Group', sortable: false, align: 'center',value: 'respNmeng',   },              
              { text: 'Description', sortable: true, align: 'center',value: 'itemDescShort',  width: '300px' },
              { text: 'NDT of kind', sortable: false, align: 'center',value: 'ndtKind', },
              { text: 'QM part', sortable: false, align: 'center',value: 'qmPart',  },
              { text: 'Location', sortable: false, align: 'center',value: 'insLocNo',   },
              { text: 'Inspection result', sortable: false, align: 'center',value: 'insRes',  },
              { text: 'Welder name', sortable: false, align: 'center',value: 'wedEmp',   },
              { text: 'NDT No', sortable: false, align: 'center',value: 'ndtNo',  },
            ],
  selectedRowIndex: null, // Lưu index của dòng đang được chọn 
    // Chỉ cần khai báo list này là giao diện tự sinh ra
    mobileFields: [
      { label: 'Ship No', key: 'shipNo' },
      { label: 'Req. Date', key: 'reqDate' },
      { label: 'Insp. Date', key: 'insDate' },
      { label: 'Department', key: 'deptNm' },
      { label: 'Work Group', key: 'respNmeng' },
      { label: 'Description', key: 'itemDescShort' },
      { label: 'NDT of kind', key: 'ndtKind' },
      { label: 'QM part', key: 'qmPart' },
      { label: 'Inspection result', key: 'insRes' },
      { label: 'Welder name', key: 'wedEmp' },

    ],                      
}),
components: {
  DxDateBox,
  // AppButton,
},

computed: {
  },

  watch: {
    /*  options: {
    handler () {
      this.btnRetrieve()
    },
    deep: true,
  }, */
  },
  created() {
    EventBus.$on(this.$options.name + "_search", () => { 
      this.btnRetrieve();
    });
  },
  mounted() {
    // Khởi tạo filter ngay khi có headers
    this.initColumnFilters(this.headers);
    this.init()
     //Apply for Fab
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);

    this.loadColumnWidths(); // Khôi phục ngay khi load trang
    
    // Lắng nghe sự kiện thả chuột để lưu lại kích thước mới
    this.$el.querySelector('.v-data-table').addEventListener('mouseup', () => {
      // Đợi một chút để trình duyệt cập nhật xong style.width
      setTimeout(() => {
        this.saveColumnWidths();
      }, 100);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
    EventBus.$off(this.$options.name + "_search");
  },
  methods: {
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop () {
      this.$vuetify.goTo(0)
    },
    
    btnRetrieve() {
        this.gridMainList = []
        // this.panel = []
        this.getMainList()
    },
    getStrFormat(date) {
      this.stDate = getDateFormat(date)
      return getDateFormat(date)
    },
    init() {
      let toDay = new Date
      toDay.setDate(toDay.getDate() + 0);
      this.stDate = toDay

      this.getList()

    },
    //getList
    async getList() {
      try {
          this.openLoading('searching')
          let params1 = {
            shipNo: '',
          }
          let params2 = {
            deptCd: '',
          }

          await getQMPartList(params1).then(res => {
                this.qmPartNameList.push('All')
                res.list.forEach(e => {
                  if (e.qmPart != 'A') {
                    this.qmPartNameList.push(e.qmPart + ' : ' + e.qmPartNm)
                  }                  
                });
                this.qmPartName = this.qmPartNameList[0]
              })

          await getShipList(params1).then(res => {
                  this.shipNoList.push('All')
                  res.list.forEach(e => {
                    this.shipNoList.push(e.shipNo)
                  });
                  this.shipNo = this.shipNoList[0]
                })
          // getDepartment         
          if (this.$store.state.user.deptCd !='ZN' && this.$store.state.user.deptCd !='ZB'){
              this.deptNameList.push(this.$store.state.user.deptCd + ' : ' + this.$store.state.user.deptNm)
              this.deptName = this.deptNameList[0]
              this.deptCd = this.$store.state.user.deptCd
          }else{
            await getDeptList(params2).then(res => {
                    this.deptNameList.push('All')
                    res.list.forEach(e => {
                      this.deptNameList.push(e.deptCd + ' : ' + e.deptNm)
                    });
                    this.deptName = this.deptNameList[0]
                  })
              }

          } finally {
              this.groupList()
              this.endLoading()
          }

    },
    //get Group
    groupList(){
    this.respNameList = []

    let supdeptCd = this.deptName
    supdeptCd = supdeptCd.split(' : ')
    this.deptCd = supdeptCd[0]
    // console.log('######deptCd===>', this.deptCd)

    let params = {
      deptCd: this.deptCd ==='All'?'':this.deptCd,
    }

    getRespList(params).then(res => {
      this.respNameList.push('All')
      res.list.forEach(e => {
        this.respNameList.push(e.respCd + ' : ' + e.respNm)										
      });
      this.respName = this.respNameList[0]
    })
  },        

  async getMainList() {
        try {
            this.openLoading('searching')
            
            let respName = this.respName
                respName = respName.split(' : ')
                this.respCd = respName[0]
            
            let qmPartName = this.qmPartName
                qmPartName = qmPartName.split(' : ')  
                this.qmPart = qmPartName[0] 

            let params = {
                stDate: this.stDate,
                shipNo: this.shipNo === 'All' ? '' : this.shipNo,
                deptCd: this.deptCd === 'All' ? '' : this.deptCd,
                respCd: this.respCd === 'All' ? '' : this.respCd,
                qmPart: this.qmPart === 'All' ? '' : this.qmPart,
            }
            
            // console.log('######getMainList===>', params)

            await v80c1010List(params).then(res => {
              let list = []
              // Hàm chuyển đổi chung
              const toBool = (val) => val === 'Y';
              // console.log('######v80c1010List===>', res)
                res.list.forEach(e => {
                  list.push({
                    ...e,
                    insDate: e.insDate + '  '+ e.insTime,
                    reqDate: e.reqDate + '  '+e.reqTime,
                    ndtKind: (e.ndtKind==='T' ? 'UTM':(e.ndtKind==='F' ? 'FTP': e.ndtKind + 'T')),
                    wedEmp: e.wedEmp + ': '+ e.wedEmpNm,
                    insLocNo: e.insLocNo===null ? '' : e.insLocNo +'/'+ e.insLocNoNm,
                    qmPart: e.qmPart==='H' ? 'Hull':'Outfitting',
                    wow: toBool(e.wow),
                    wcl: toBool(e.wcl),
                    wqm: toBool(e.wqm),
                    insRes: (e.insRes===null||e.insRes==='')? 'Not yet' : e.insRes,
                  })
                  
                });

                this.gridMainList = list
                this.listSize = this.gridMainList.length;

                if (this.listSize > 0 && this.isMobileDevice) {
                  this.panel = [];
                }
                // console.log('######gridMainList===>', this.gridMainList)
            })

        } finally {
            this.endLoading()
        }
  },

  // Hàm lưu độ rộng vào localStorage
  saveColumnWidths() {
    const widths = {};
    const ths = this.$el.querySelectorAll('.v-data-table th');
    
    ths.forEach((th, index) => {
      // Lưu theo index hoặc value của header để không bị lẫn
      widths[index] = th.style.width;
    });
    
    localStorage.setItem(`table_width_${this.$options.name}`, JSON.stringify(widths));
  },

  // Hàm khôi phục độ rộng khi vào lại trang
  loadColumnWidths() {
    const savedWidths = localStorage.getItem(`table_width_${this.$options.name}`);
    if (savedWidths) {
      const widths = JSON.parse(savedWidths);
      this.$nextTick(() => {
        const ths = this.$el.querySelectorAll('.v-data-table th');
        ths.forEach((th, index) => {
          if (widths[index]) {
            th.style.width = widths[index];
          }
        });
      });
    }
  },
  getColor (calories) {
      if (calories > 40) return 'red'
      else if (calories > 20) return 'orange'
      else return 'green'
  },  

},

};
</script>
<style>
/* Import file CSS dùng chung cho toàn bộ Mobile Card */
/* Sử dụng dấu ~ trước @ để Webpack nhận diện đúng alias */
@import "~@/assets/css/mobile-table.css";

/* Các CSS tùy chỉnh khác cho menu này */
.border-bottom {
  border-bottom: 1px dashed #eee;
}
.v-card__text {
  max-height: 70vh; /* Giới hạn chiều cao popup trên mobile */
}

.custom-pc-row td .v-image__image {
  background-size: contain !important; /* Đảm bảo ảnh vẽ kỹ thuật luôn thấy hết chi tiết */
}

/* Trong mobile-table.css hoặc style của v80w1010.vue */
.cursor-pointer {
  cursor: zoom-in !important; /* Đổi icon chuột thành hình kính lúp */
  transition: opacity 0.3s;
}

.cursor-pointer:hover {
  opacity: 0.8; /* Hiệu ứng mờ nhẹ khi di chuột qua */
}

/* Hiệu ứng cho icon kẹp giấy */
.pdf-icon-btn {
  transition: all 0.2s ease-in-out; /* Giúp hiệu ứng mượt mà hơn */
  cursor: pointer;
}

/* Khi di chuột vào trên PC */
.pdf-icon-btn:hover {
  transform: scale(2); /* Phóng to 30% */
  color: #d32f2f !important; /* Đổi sang màu đỏ đậm hơn (v-red-darken-2) */
  filter: drop-shadow(0px 2px 4px rgba(0,0,0,0.2)); /* Thêm bóng đổ nhẹ */
}

/* Hiệu ứng khi nhấn vào (Active) */
.pdf-icon-btn:active {
  transform: scale(1.1);
  opacity: 0.7;
}

/* Thu hẹp khoảng cách giữa checkbox và label trong Vuetify 2 */
.v-application--is-ltr .v-input--selection-controls__input {
  margin-right: 1px !important; 
}

/* Tùy chỉnh màu label cho đậm nét hơn trên mobile nếu cần */
.v-input--selection-controls .v-label {
  font-size: 13px !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

/* Làm gọn Header */
.custom-header-cell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 4px;
}

.header-text {
  font-size: 0.85rem;
  font-weight: 600;
  color: #555;
  white-space: nowrap;
}

/* Tùy chỉnh Row để nhìn sang hơn */
.custom-pc-row:hover {
  background-color: #f5faff !important; /* Màu xanh nhẹ khi hover dòng */
}

.v-data-table__divider {
  border-right: 1px solid #f0f0f0 !important; /* Đường kẻ dọc mảnh hơn */
}

/* Bo góc cho các input trong Search Condition */
.v-expansion-panel-content .v-input--outlined > .v-input__control > .v-input__slot {
  border-radius: 8px !important;
  background-color: #fafafa !important;
}

/* Nút Fab tìm kiếm */
.v-btn--fab {
  box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
}
</style>
